import fetchData from "../utils/HttpClient";
import TriggerEventInterface from "../interfaces/core/TriggerEventInterface";

export async function saveTriggerEvents(events: TriggerEventInterface[]): Promise<{status: boolean}> {
    return fetchData('/api/trigger-events', {
        events: events
    }, 'POST')
}